import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { Formik } from 'formik';
import { loginValidation, loginValidationForFamily } from 'validation/auth.validation';
import Button from '../CustomComponents/Button';
import Text from 'components/shared/Text';
import styles from './style.module.css';
import CustomTextField from '../CustomComponents/TextField';
import { Checkbox } from '@mui/material';
import PasswordTextfield from '../CustomComponents/PasswordTextfield';
import { emailIcon } from 'assets/newIcons';
import history from 'store/history';
const initialValues = { email: '', password: '', idCA: '' };

const Main = ({
  login,
  isRequesting,
  requestType,
  error,
  clearError,
  isFamily,
  checkFamilyIsRequesting,
  isMobile,
  onFormErrors,
}) => {
  const [showError, setShowError] = useState(false);
  const newOlsUrl = process.env.REACT_APP_NEW_OLS_URL;

  //Remember me
  const [rememberMe, setRememberMe] = useState(false);
  const handleRememberMe = () => {
    setRememberMe(!rememberMe);
  };
  useEffect(() => {
    const storedRememberMe = localStorage.getItem('rememberMe');
    if (storedRememberMe === 'false') {
      setRememberMe(false);
    } else if (storedRememberMe === 'true') {
      setRememberMe(true);
    } else {
      setRememberMe(false);
    }
  }, []);

  useEffect(() => {
    if (requestType === 'LOGIN_FAILURE' && error !== 'User is not exist') {
      setShowError(true);
      if (onFormErrors) {
        onFormErrors(true);
      }
    }
  }, [requestType, error, onFormErrors]);

  const handleForgotPasswordClick = () => {
    clearError();
  };

  return (
    <div className={styles.mainContainer}>
      <Formik
        initialValues={initialValues}
        onSubmit={values => {
          login(values);
          localStorage.setItem('rememberMe', rememberMe);
        }}
        validationSchema={isFamily ? loginValidationForFamily : loginValidation}
      >
        {({
          handleSubmit,
          handleChange,
          values,
          errors,
          touched,
          isValid,
          dirty,
          handleBlur,
        }) => {
          // Remove the useEffect and call onFormErrors directly
          if (onFormErrors) {
            const hasFormErrors = 
              (touched.email && Boolean(errors.email)) || 
              (touched.password && Boolean(errors.password)) ||
              showError;
            onFormErrors(hasFormErrors);
          }

          return (
            <form
              className={`${styles.form} ${isMobile ? styles.mob : null} login-form`}
              onSubmit={handleSubmit}
            >
              <CustomTextField
                onChange={e => {
                  setShowError(false);
                  handleChange(e);
                }}
                value={values.email}
                invalid={showError ? true : touched.email && Boolean(errors.email)}
                error={errors.email}
                name="email"
                onBlur={handleBlur}
                disabled={isRequesting}
                type="email"
                placeholder="Email Address"
              />
              <PasswordTextfield
                onChange={e => {
                  setShowError(false);
                  handleChange(e);
                }}
                value={values.password}
                invalid={showError ? true : touched.password && Boolean(errors.password)}
                error={showError ? error : errors.password}
                name="password"
                placeholder="Password"
                onBlur={handleBlur}
                disabled={isRequesting}
              />
              <div className={styles.checkboxWrapper}>
                <p>Remember Me</p>
                <Checkbox
                  sx={{
                    '& .MuiSvgIcon-root': {
                      color: 'black !important',
                    },
                    '&.Mui-checked, &.Mui-checked .MuiSvgIcon-root': {
                      color: 'black !important',
                    },
                  }}
                  checked={rememberMe}
                  onClick={() => handleRememberMe()}
                />
              </div>

              <Button
                disabled={!(isValid && dirty) || isRequesting || checkFamilyIsRequesting}
                isRequesting={isRequesting || checkFamilyIsRequesting}
                className={`${styles.button} ${isMobile ? styles.mob : ''}`}
                type="submit"
              >
                Sign In
              </Button>
              <NavLink to="/reset_password" onClick={handleForgotPasswordClick}>
                <Text className={styles.text}>Forgot Password?</Text>
              </NavLink>

              <div className={styles.orDividerContainer}>
                <div className={styles.orDividerLine}></div>
                <span className={styles.orText}>Or</span>
                <div className={styles.orDividerLine}></div>
              </div>

              <button
                type="button"
                className={styles.oneTimeLoginBtn}
                onClick={() => {
                  history.push('/one-time-login-link');
                }}
              >
                <div className={styles.emailIconContainer}>
                  <img className={styles.emailIcon} src={emailIcon} alt="Email icon" />
                </div>
                <span className={styles.oneTimeLoginText}>Send One-Time Login Link</span>
              </button>
              {!navigator.cookieEnabled && (
                <div className={styles.cookiesDisabled}>
                  Cookies are disabled. For the best performance please enable cookies in
                  browser settings and refresh the page.
                </div>
              )}
            </form>
          );
        }}
      </Formik>
      <hr className={styles.fullWidthDivider} />
      <p className={styles.text2}>
        Not a Member?{' '}
        <a href={newOlsUrl} className={styles.joinLink}>
          JOIN NOW
        </a>
      </p>
    </div>
  );
};

Main.propTypes = {
  login: PropTypes.func.isRequired,
  requestType: PropTypes.string,
  isRequesting: PropTypes.bool,
  error: PropTypes.string,
  clearError: PropTypes.func.isRequired,
  loginWithService: PropTypes.func.isRequired,
  isFamily: PropTypes.bool,
  checkFamilyIsRequesting: PropTypes.bool,
  onFormErrors: PropTypes.func,
};

Main.defaultProps = {
  requestType: '',
  isRequesting: false,
  error: null,
  isFamily: false,
  checkFamilyIsRequesting: false,
  onFormErrors: null,
};

export default Main;
